<template>
  <div class='un_design_controls' :class='{active: imageIsSelected}'>

    <p class='un_below_image_controls'>
      <span v-tap='handleCenterImageClick' class='small-btn mar_r_1' :disabled='!userImageExists'>
        Center Image
      </span>

      <span v-tap='handleRemoveImageClick' class='small-btn' :disabled='!userImageExists'>
        Remove Image
      </span>
    </p>

    <div class='un_design_controls-wrap'>
      <!--
        Todo each of these can likely become wrapped in a higher order component.
        Lots of duplication that can become a source of errors.
      -->

      <!-- Scale & Rotate Button -->
      <div
        class='disp_ib cur_p pos_r un_control_wrap scale-rotate_wrap'
        :class='{selected: isActiveControl("scaleRotate")}'
        v-tap='(e) => setActiveControl("scaleRotate")'>
        <div class='icons-wrap'>
          <div v-tap='handleCancelScaleRotate' v-if='isAdjustmentEnabled("scale")'>
            <IconCancelEdit class='cancel-icon' />
          </div>

          <IconScaleRotate class='disp_ib z_2 pos_r' :class='{selected: isActiveControl("scaleRotate")}' />

          <span class='control-label'>
            Scale & Rotate
          </span>
        </div>
      </div>

      <!-- Brightness / Contrast Button -->
      <div
        class='disp_ib cur_p pos_r un_control_wrap brighten-contrast_wrap'
        :class='{selected: isActiveControl("light")}'
        v-tap='(e) => setActiveControl("light")'>
        <div class='icons-wrap'>
          <div v-tap='handleCancelBrightnessContrast' v-if='isAdjustmentEnabled("light")'>
            <IconCancelEdit class='cancel-icon' />
          </div>

          <IconBrightenContrast class='disp_ib z_2 pos_r' :class='{selected: isActiveControl("light")}' />

          <span class='control-label'>
            Brighten/Contrast
          </span>
        </div>
      </div>

      <!-- Filters Button -->
      <div
        class='disp_ib cur_p pos_r un_control_wrap filters_wrap'
        :class='{selected: isActiveControl("filter")}'
        v-tap='(e) => setActiveControl("filter")'>
        <div class='icons-wrap'>
          <div v-tap='handleCancelFilters' v-if='isAdjustmentEnabled("filter")'>
            <IconCancelEdit class='cancel-icon' />
          </div>

          <IconFilters class='disp_ib z_2 pos_r' :class='{selected: isActiveControl("filter")}' />

          <span class='control-label'>
            Filters
          </span>
        </div>
      </div>
    </div>

    <div class='un_design_controls-options'>
      <div id='un_designcontrol_knobs'>
        <div id='un_edit_menu_options' class='z_4' @mousedown='checkForSelectionAndAlert'>
          <ControlOptions
            :activeControl='activeControl'
            :canvas='canvas'
            :currentImage='currentImage'
            :imageIsSelected='imageIsSelected'
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ALERT_USER_EVENT,
  unUi
} from '@/components/EventBuses'

import ControlOptions from './ControlOptions.vue'
import IconBrightenContrast from '$svgs/IconBrightenContrast.vue'
import IconCancelEdit from '$svgs/IconCancelEdit.vue'
import IconFilters from '$svgs/IconFilters.vue'
import IconScaleRotate from '$svgs/IconScaleRotate.vue'

export default {
  props: [
    'activeControl',
    'canvas',
    'currentImage',
    'imageIsSelected',
    'userImageExists'
  ],

  data () {
    return {
      enabledAdjustments: {
        scale: false,
        light: false,
        filter: false
      }
    }
  },

  methods: {
    isAdjustmentEnabled (adjustmentName) {
      return this.enabledAdjustments[adjustmentName] === true
    },

    setActiveControl (controlName) {
      this.$emit('imageControlChanged', controlName)
    },

    isActiveControl (controlName) {
      return this.activeControl === controlName
    },

    handleCancelFilters () {
      unUi.$emit('resetFilters')
      this.enabledAdjustments.filter = false
    },

    handleCancelBrightnessContrast () {
      unUi.$emit('resetBrightness')
      this.enabledAdjustments.light = false
    },

    handleCancelScaleRotate () {
      this.enabledAdjustments.scale = false
      unUi.$emit('resetScale')
    },

    handleCenterImageClick () {
      unUi.$emit('centerImage')
    },

    handleRemoveImageClick () {
      if (!confirm('Are you sure that you would like to remove your image?')) {
        return
      }

      this.$emit('removeImage')
    },

    checkForSelectionAndAlert () {
      if (!this.imageIsSelected) {
        unUi.$emit(ALERT_USER_EVENT, {
          message: 'Please select the image to adjust it.',
          type: 'warning'
        })
      }
    }
  },

  mounted () {
    unUi.$on('lightChanged', () => {
      this.enabledAdjustments.light = true
    })

    unUi.$on('filterChanged', () => {
      this.enabledAdjustments.filter = true
    })

    unUi.$on('filterRemoved', () => {
      this.enabledAdjustments.filter = false
    })

    unUi.$on('scaleChanged', () => {
      this.enabledAdjustments.scale = true
    })

    unUi.$on('noFilters', () => {
      this.enabledAdjustments.filter = false
    })
  },

  watch: {
    currentImage: function (newImage, oldImage) {
      // Watch the current image, and reset our enabled adjustments
      // if the image has changed and become empty.
      if (!newImage) {
        this.enabledAdjustments = {
          scale: false,
          light: false,
          filter: false
        }
      }
    }
  },

  components: {
    ControlOptions,
    IconBrightenContrast,
    IconCancelEdit,
    IconFilters,
    IconScaleRotate
  }
}
</script>

<style lang='scss' scoped>
.un_design_controls {
  opacity: 0.2;
  transition: all 0.2s ease-in-out;
  pointer-events: none;

  &.active {
    opacity: 1;
    pointer-events: all;
  }
}

.icon {
  width: 2.5rem;
  height: 2.5rem;
  vertical-align: middle;
  margin: $mar_designcontrols_btn-icon;
  padding: $pad_designcontrols_btn-icon;

  &.icon-brighten-contrast {
    width: 2.7rem;
    height: 2.7rem;
  }

  &.icon-filters {
    width: 2.8rem;
    height: 2.9rem;
  }
}

.un_below_image_controls {
  height: 20%;
  display: block;

  span.small-btn {
    touch-action: manipulation;
    display: inline-block;
    padding: 0.25rem 1rem;
    background: #EEE;
    border-radius: 1rem;
    font-size: 1.2rem;
    cursor: pointer;

    &:hover {
      background: #DDD;
    }
  }

}

.un_design_controls-wrap {
  height: 30%;
  display: flex;
  flex-flow: row nowrap;
}

.un_design_controls-options {
  position: relative;
  height: 50%;

  @include respond-to("small") {
    background-color: #F5F5F5;
  }
}

.un_control_wrap {
  position: relative;
  padding: 0 6% 4% 6%;
  border-bottom: 1px solid #CBCBCB;
  width: 33.333333%;

  &:after {
    position: absolute;
    content: '';
    display: block;
    background-color: #0000FF;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 0.1rem;
    z-index: 1;
    opacity: 0;
    visibility: hidden;

    @include t_btn_hover;
  }

  .icons-wrap {
    position: relative;
    display: inline-block;
  }

  .cancel-icon {
    position: absolute;
    z-index: 22;
    width: 1.3rem;
    height: 1.3rem;
  }

  &.scale-rotate_wrap {
    .cancel-icon {
      top: -0.8rem;
      left: 0.15rem;
    }
  }

  &.brighten-contrast_wrap {
    .cancel-icon {
      top: -0.7rem;
      left: 1.15rem;
    }
  }

  &.filters_wrap {
    .cancel-icon {
      top: -0.6rem;
      left: -0.4rem;
    }
  }

  .icons-wrap {
    position: relative;
  }

  .icon.garbage {
    width: 1.5rem;
    height: 1.9rem;
  }

  .control-label {
    display: block;
    text-align: center;

    @include type_medium;
    @include font-size(0.9);

    margin-top: 0.7rem;
  }

  &.filters_wrap {
    margin-right: 0;
  }

  &.selected {
    border-bottom: 1px solid #0000FF;

    &:after {
      opacity: 1;
      visibility: visible;
    }

    .control-label {
      color: #0000FF;
    }
  }

  &:hover {
    &:after {
      // opacity:0.5;
      // visibility: visible;

    }

    &.selected {
      border-bottom: 1px solid #0000FF;

      &:after {
        opacity: 1;
        visibility: visible;
      }

      .control-label {
        color: #0000FF;
      }
    }
  }

  .el-slider .el-slider__runway .el-slider__button-wrapper .el-slider__button {
    width: 20px;
    height: 20px;
  }
}

#un_design_reset {
  vertical-align: middle;

  p {
    text-transform: uppercase;
    font-size: 0.9rem;
    letter-spacing: 0.05;
    text-decoration: underline;
    color: $c_pure_blue;
  }
}

#un_designcontrol_knobs {
  position: relative;
  top: 50%;
  width: 100%;
  height: 100%;
  transform: translateY(-50%);
  overflow-x: scroll;

  #un_edit_menu_options {
    position: relative;
    top: 50%;
    width: 100%;
    transform: translateY(-50%);
  }
}

</style>



// WEBPACK FOOTER //
// uncommon-client/components/product-designer/design-controls/DesignControls.vue